export default __webpack_public_path__ + "static/g2_thumb-db22bd41132f95875f79f97b7fcda07a.png";